import * as React from "react"
// @ts-ignore
import { saListSection,saTitleContainer,saTitle,saSubtitleContainer,saSubtitle,saBlocks } from './saList.module.scss'
import { saInterfaceListContainer } from "../saTypes"
import { SaTitle } from "../saTitle/saTitle"
import { SaSubtitle } from "../saTitle/saSubtitle"
import { SaList } from "./saList"



export const SaListContainer: React.FC<saInterfaceListContainer> = ({ ...props }) =>{

  let gridDesk: string = ' gridUlDesk-2'
  let gridTab: string = ' gridUlTab-2'
  let gridMob: string = ' gridUlMob-1'

  if (props.list.gridDesk){
    gridDesk = ' gridUlDesk-' + props.list.gridDesk
  }

  if (props.list.gridTab){
    gridTab = ' gridUlTab-' + props.list.gridTab
  }

  if (props.list.gridMob){
    gridMob = ' gridUlMob-' + props.list.gridMob
  }




    return (
      <section id={'saListSection'}
               className={saListSection}
      >

        <div className={'saContainer'}>

          {
            props.sectionTitle &&
            <div className={saTitleContainer}>
              <SaTitle title={props.sectionTitle} classes={saTitle}/>
            </div>
          }

          {
            props.subtitle &&
            <div className={saSubtitleContainer}>
              <SaSubtitle title={props.subtitle} classes={saSubtitle}/>
            </div>
          }

          {
            props.list.blocks &&
            <div className={saBlocks + gridDesk + gridTab + gridMob}>
              <SaList {...props.list.blocks} />
            </div>
          }


        </div>


      </section>
    )

}
